const state = {
  isLoading: false,
  isGatesLoading: false,
  isDocksLoading: false,
  gates: {},
  depot: {},
  docks: {},
  all: null,
  isUploading: false,
  isDownloading: false,
  filter: {},
  isPaginating: false,
  hasEmpty: false,
};

export default state;
